import useTranslation from 'next-translate/useTranslation'

import Button from '@/atoms/TempButton'

function PickButton({ isDisabled, onClick }: PickButtonProps) {
  const { t } = useTranslation('global')
  const text = isDisabled ? 'sold_out' : 'i_choose'

  return (
    <Button
      onClick={onClick}
      disabled={isDisabled}
      className="px-8 py-3 text-sm font-medium max-w-max"
      variant="rounded_solid"
    >
      {t(text)}
    </Button>
  )
}

interface PickButtonProps {
  isDisabled: boolean
  onClick(): void
}

export default PickButton
